export default __webpack_public_path__ + "static/media/generic-document.7f5407a8.jpg";